import React, { forwardRef, useImperativeHandle } from 'react';
import { View, StyleSheet } from 'react-native';

export interface SwipeableTabsRef {
  setPage: (index: number) => void;
}

interface SwipeableTabsProps {
  activeIndex: number;
  onPageSelected: (index: number) => void;
  children: React.ReactNode;
}

const SwipeableTabs = forwardRef<SwipeableTabsRef, SwipeableTabsProps>(
  ({ activeIndex, children }, ref) => {
    useImperativeHandle(ref, () => ({
      setPage: () => {},
    }));

    const childArray = React.Children.toArray(children);
    return (
      <View style={styles.container}>
        {childArray[activeIndex]}
      </View>
    );
  }
);

SwipeableTabs.displayName = 'SwipeableTabs';
export default SwipeableTabs;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
